import React from "react";
import FeedbackImg from "../school_images/feedback_bg.jpg";
import Navbaartesting from "../components/Navbaartesting";
import Footer from "../components/Footer";
import ContactImg from "../school_images/contact_us.jpg";
import { FaFacebook } from "react-icons/fa";
import { IoLogoYoutube } from "react-icons/io";
import { FaInstagramSquare } from "react-icons/fa";
import { IoLogoLinkedin } from "react-icons/io5";
import { Link } from "react-router-dom";
import styled from "styled-components";

const Contactus = () => {
  return (
    <div>
      <Navbaartesting />
      <MainImageDiv>
        <img src={ContactImg} alt="Career_image" className="w-full" />
        <SocialMediaIconsDiv>
          <div className=" w-[60px] h-[60px] border-2 rounded-full flex items-center justify-center mb-3">
            <Link
              to="https://www.facebook.com/erajaythakur007"
              target="_blank"
            >
              <FaFacebook />
            </Link>
          </div>
          <div className=" w-[60px] h-[60px] border-2 rounded-full flex items-center justify-center mb-3">
            <Link
              to="https://www.youtube.com/@srksoftwares"
              target="_blank"
            >
              <IoLogoYoutube />
            </Link>
          </div>
          <div className=" w-[60px] h-[60px] border-2 rounded-full flex items-center justify-center mb-3">
            <Link
              to="https://www.instagram.com/srksoftwares/"
              target="_blank"
            >
              <FaInstagramSquare />
            </Link>
          </div>
          <div className=" w-[60px] h-[60px] border-2 rounded-full flex items-center justify-center mb-3 ">
            <Link
              to="https://www.linkedin.com/in/meetajaythakur007/"
              target="_blank"
            >
              <IoLogoLinkedin />
            </Link>
          </div>
        </SocialMediaIconsDiv>
        <MainHeading className=" font-bold pt-10 px-10 uppercase  absolute ">
          Contact
        </MainHeading>
      </MainImageDiv>

      <ContactUsContainer>
        <MapDiv>
          <iframe
            title="My Map"
            width="100%"
            frameborder="0"
            style={{ height: "100%" }}
            src="https://www.google.com/maps/embed?pb=!1m14!1m12!1m3!1d3598.410355952252!2d85.04206239999999!3d25.591276999999998!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!5e0!3m2!1sen!2sin!4v1759230360400!5m2!1sen!2sin"
            allowfullscreen=""
            loading="lazy"
            eferrerpolicy="no-referrer-when-downgrade"
          ></iframe>

      
        </MapDiv>
        <AddressDiv>
          <h1>Reach us</h1>
          <p>
            Have a question or need assistance? Our team of professional experts
            is here to help you 24/7. Whether you have feedback, inquiries, or
            require support, we are just a message or phone call away. Feel free
            to reach out to us using the contact details provided below.
          </p>
          <div>
            <i class="flaticon-world-globe"></i>
            <div>
              <h2>Our Address:</h2>
              <p>
              Road-A5, Chanakyapuri Colony behind Batala Factory Garikhana, Danapur, Khagaul Patna, Bihar 801105 India
              </p>
            </div>
          </div>
          <div>
            <i class="flaticon-world-globe"></i>
            <div>
              <h2>Our Mailbox:</h2>
              <p>
                <a href="mailto:ajaykrthakur02@gmail.com">
                  info@srksoftwares.com
                </a>
              </p>
            </div>
          </div>
          <div>
            <i class="flaticon-world-globe"></i>
            <div>
              <h2>Call Us on:</h2>
              <p>
                <a href="tel:+9162013119591">+91 62013119591</a>,

              </p>
            </div>
          </div>
        </AddressDiv>
      </ContactUsContainer>
      <WriteFeedback>
        <form>
          <h1>Write Suggestions to Us:</h1>
          <Div>
            <Div1>
              <label>Name*:</label>
              <input
                type="text"
                name="name"
                // value={formData.name}
                // onChange={handleChange}
                required
              />
            </Div1>

            <Div1>
              <label>Email*:</label>
              <input
                type="email"
                name="email"
                // value={formData.email}
                // onChange={handleChange}
                required
              />
            </Div1>
            <Div1>
              <label>Phone Number*:</label>
              <input
                type="tel"
                name="phoneNumber"
                // value={formData.phoneNumber}
                // onChange={handleChange}
                required
              />
            </Div1>

            <Div1>
              <label>Write to us here</label>
              <textarea
                rows="5"
                cols="30"
                name="message"
                // value={formData.message}
                // onChange={handleChange}
              ></textarea>
            </Div1>
          </Div>
        </form>

        <GoogleFeedback>
          <h3>Write Feedback on Google</h3>
          <img src={FeedbackImg} alt="feedbackImage" />
          <a href="https://g.page/r/CX0yrqBY9lNoEBM/review">
            Please Click Me
          </a>
        </GoogleFeedback>
      </WriteFeedback>
      <Footer />
    </div>
  );
};

export default Contactus;

const GoogleFeedback = styled.div`
  width: 50%;
  height: 100%;
  position: relative;
  a {
    border: 1px solid rgb(251 191 36);
    padding: 5px 25px;
    font-size: 20px;

    background-color: rgb(251 191 36);
    color: white;
    font-weight: 600;
    text-align: center;
    text-decoration: none;
    border-radius: 5px;
    position: absolute;
    top: 48%;
    right: 20%;
    &:hover {
      color: rgb(251 191 36);
      background-color: white;
    }
  }
  img {
    background-size: cover;
    background-position: center;
    height: 100%;
    width: 100%;
  }
  h3 {
    z-index: 2;
    color: rgb(251 191 36);
    font-weight: 700;
    font-size: 30px;
    position: absolute;
    right: 0%;
    text-align: right;
  }
`;

const Div = styled.div`
  @media (max-width: 768px) {
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
  }
`;

const Div1 = styled.div`
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  justify-content: flex-start;
  width: 600px;
  margin-bottom: 1%;
  label {
    font-size: 1.3rem;
    opacity: 0.8;
  }
  input {
    width: 100%;
    border: 2px solid #ccc;
    padding: 10px;
  }
  textarea {
    width: 100%;
    border: 2px solid #ccc;
    padding: 10px;
  }
`;

const WriteFeedback = styled.div`
  padding: 0% 7%;
  text-align: left;
  color: black;
  display: flex;
  justify-content: space-between;
  align-items: center;
  p {
    text-align: left;
    font-size: 20px;
    margin-bottom: 20px;
    font-weight: 300;
    @media (max-width: 500px) {
      font-size: 16px;
    }
  }
  h2 {
    font-weight: 500;
    font-size: 25px;
    @media (max-width: 500px) {
      font-size: 20px;
    }
  }
  h1 {
    font-size: 40px;
    text-transform: uppercase;
    // color: #2c975b;
    color: red;
    margin-bottom: 1rem;
    font-weight: 700;
    @media (max-width: 500px) {
      font-size: 30px;
      font-weight: 500;
    }
  }
`;

const MapDiv = styled.div`
  width: 60%;
  min-height: 350px;
`;

const AddressDiv = styled.div`
  width: 40%;
  background-color: red;
  padding-left: 20px;
  a {
    &:hover {
      color: #000;
    }
  }
`;

const ContactUsContainer = styled.div`
  padding: 0% 0%;
  text-align: left;
  display: flex;
  color: white;
  p {
    text-align: left;
    font-size: 20px;
    margin-bottom: 20px;
    font-weight: 300;
    @media (max-width: 500px) {
      font-size: 16px;
    }
  }
  h2 {
    font-weight: 500;
    font-size: 25px;
    @media (max-width: 500px) {
      font-size: 20px;
    }
  }
  h1 {
    font-size: 40px;
    text-transform: uppercase;
    text-decoration: underline;
    margin-bottom: 1rem;
    font-weight: 600;
    @media (max-width: 500px) {
      font-size: 30px;
    }
  }
`;

const MainHeading = styled.span`
  position: absolute;
  bottom: 10%;
  right: 10%;
  color: #2c975b;
  font-size: 50px;
`;

const MainImageDiv = styled.div`
  padding: 0 0%;
  max-height: 500px;
  min-height: 330px;
  position: relative;
  img {
    max-height: 500px;
    height: 100%;
    width: 100%;
    min-height: 330px;
  }
`;

const SocialMediaIconsDiv = styled.span`
  color: #fff;
  position: absolute;
  top: 20%;
  right: 2%;
  a {
    color: #fff;
    font-size: 30px;
    &:hover {
      color: brown;
    }
  }
  div {
    @media (max-width: 640px) {
      font-size: 25px;
      width: 45px;
      height: 45px;
    }
  }
`;
